export const IMPERSONATION_AMR = 'impersonation'

export const SESSION_FALLBACK = {
  USER_ID: 'anonymous',
  VALUE: 'none',
} as const

export const SESSION_FLAGS = {
  TRUE: '1',
  FALSE: '0',
} as const

export const SESSION_PARTS = {
  USER: 'u',
  ACCOUNT: 'a',
  SUBJECT: 's',
  AUTH_STATE: 'as',
  IMPERSONATION: 'imp',
  BUYER_MODE: 'buyer',
  URL_TOKEN: 'url',
} as const
